import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialDataConnectState } from "./initializes";
import type { DataConnect } from "./types";

const dataConnectSlice = createSlice({
  name: "DataConnect",
  initialState: initialDataConnectState,
  reducers: {
    setAppConnectData: (state: DataConnect, action: PayloadAction<Object>) => {
      state.appConnectData = action.payload;
    },
    setIsDbConnecting: (state: DataConnect, action: PayloadAction<boolean>) => {
      state.isDbConnecting = action.payload;
    },
    setConnectingColumns: (state: DataConnect, action: PayloadAction<number[]>) => {
      state.connectingColumns = action.payload;
    },
    setYoomDatabaseEditData: (state: DataConnect, action: PayloadAction<object | null>) => {
      state.yoomDatabaseEditData = action.payload;
    },
    setRelationUpdateCurrentId: (state: DataConnect, action: PayloadAction<number | null>) => {
      state.relationUpdateCurrentId = action.payload;
    },
  },
});

export const {
  setAppConnectData,
  setIsDbConnecting,
  setConnectingColumns,
  setYoomDatabaseEditData,
  setRelationUpdateCurrentId,
} = dataConnectSlice.actions;

export default dataConnectSlice.reducer;
